import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../shared/services/http.service';
import { HttpClient } from '@angular/common/http';
import { encodeToBase64 } from '../../utility';

@Injectable({ providedIn: 'root' })
export class GroupService {
  private groupList = `${environment.opbBackendHost}/api/admin/group/list`;
  private createUpdate = `${environment.opbBackendHost}/api/admin/group/create`;
  private groupUpdate = `${environment.opbBackendHost}/api/admin/group/update`;
  private groupDetail = `${environment.opbBackendHost}/api/admin/group/detail`;
  private groupDownload = `${environment.opbBackendHost}/api/admin/group/download`;

  http=inject(HttpClient);
  httpService = inject(HttpService);

  createGroup(data: any): Observable<any> {
    return this.httpService.post(this.createUpdate, data);
  }

  getGroup(data: any): Observable<any> {
    return this.httpService.post(this.groupList, data);
  }

  updateGroup(data: any): Observable<any> {
    return this.httpService.post(this.groupUpdate, data);
  }

  getDetail(data: any): Observable<any> {
    return this.httpService.post(this.groupDetail, data);
  }

  downloadGroups(payload: any): Observable<Blob> {
    const data = { payload: encodeToBase64(JSON.stringify(payload)) };
    return this.http.post(this.groupDownload, data, {
      responseType: 'blob',
      withCredentials: true,
    });
  }
}
